import React from "react";
import { Box, Typography } from "@mui/material";
import { FieldLabel } from "common/fieldLabel/FieldLabel";
import { PreviewFormInputField } from "./PreviewFormInputField";
import {
  InputElementFragment,
  DisplayAs,
} from "__generated__/graphqlUnauthenticated";
import { FormikPreviewAutoCompleteField } from "../fields/FormikPreviewAutoCompleteField";

interface IPreviewFormItemProps {
  children?: React.ReactNode;
  formElement: InputElementFragment;
}
export const PreviewFormItem: React.FC<IPreviewFormItemProps> = ({
  formElement,
}) => {
  const {
    label,
    displayAs,
    placeholder,
    description,
    field,
    id,
    customField: schema,
    required,
  } = formElement;
  return (
    <Box
      sx={{
        backgroundColor: "common.white",
        py: 1,
        borderRadius: 4,
      }}
      role="button"
    >
      <FieldLabel
        label={
          displayAs === DisplayAs.ConsentStatus
            ? ""
            : (label as string) || schema?.name
        }
        labelId={`preview-form-${field}`}
        required={displayAs === DisplayAs.ConsentStatus ? false : required}
      >
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="caption">{description}</Typography>
          {field === "Education" ? (
            <FormikPreviewAutoCompleteField
              name={id!}
              labelledById={`preview-form-${field}`}
              placeholder={placeholder || ""}
            />
          ) : (
            <PreviewFormInputField
              label={
                displayAs === DisplayAs.ConsentStatus ? (label as string) : ""
              }
              type={displayAs}
              placeholder={placeholder || ""}
              labelledById={`preview-form-${field}`}
              name={id!}
              schema={schema}
              required={
                displayAs === DisplayAs.ConsentStatus ? required : false
              }
            />
          )}
        </Box>
      </FieldLabel>
    </Box>
  );
};
